import type { FC } from "react";
import { isEmailChannel, isTextChannel, isWhatsAppChannel } from "../../../../../../channels/types";
import { useEmailPreviewSource } from "../hooks/use-email-preview-source";
import { usePreviewContext } from "../preview-context";
import type { UUID } from "../../../../../../../utils/uuid";
import { PreviewBodyMjmlContent } from "./preview-body-mjml-content";
import { PreviewBodyNewsletterContent } from "./preview-body-newsletter-content";
import { PreviewBodySlackContent } from "./preview-body-slack-content";
import { PreviewBodyTeamsContent } from "./preview-body-teams-content";
import { PreviewBodyWhatsAppContent } from "./preview-body-whatsapp-content";
import { PreviewBodyTwilioContent } from "./preview-body-twilio-content";

export const PreviewBodyContent: FC<{ momentId: UUID; isNewsletter: boolean }> = ({
  momentId,
  isNewsletter,
}) => {
  const {
    moment_preview_data: { channel },
  } = usePreviewContext();

  const { use_unlayer_email_preview } = useEmailPreviewSource();

  if (isEmailChannel(channel))
    return isNewsletter || use_unlayer_email_preview ? (
      <PreviewBodyNewsletterContent />
    ) : (
      <PreviewBodyMjmlContent />
    );

  if (isTextChannel(channel)) return <PreviewBodyTwilioContent />;

  if (isWhatsAppChannel(channel)) return <PreviewBodyWhatsAppContent momentId={momentId} />;

  if (channel === "slack") return <PreviewBodySlackContent />;

  if (channel === "teams") return <PreviewBodyTeamsContent />;

  return null;
};
